

const EditSubPopup = ({editedSub, setEditedSub, handleCloseEditSub, handleUpdateSubscription, originalSub}) => (

    <div className="fixed inset-0 flex items-center justify-center bg-gray-900 bg-opacity-50">
        <div className="bg-white p-6 rounded shadow-lg w-96">
            <h2 className="text-lg font-bold mb-4">Edit Subscription</h2>
            <div className="space-y-2">
                <div>
                    <label className="block font-medium">Requests Limit</label>
                    <input
                        type="number"
                        className="border p-2 w-full"
                        value={editedSub.requests_limit}
                        onChange={(e) => setEditedSub({ ...editedSub, requests_limit: e.target.value })}
                    />
                </div>
                <div>
                    <label className="block font-medium">Concurrency</label>
                    <input
                        type="number"
                        className="border p-2 w-full"
                        value={editedSub.concurrency}
                        onChange={(e) => setEditedSub({ ...editedSub, concurrency: e.target.value })}
                    />
                </div>
                <div>
                    <label className="block font-medium">Requests Used</label>
                    <input
                        type="number"
                        className="border p-2 w-full"
                        value={editedSub.requests_used}
                        onChange={(e) => setEditedSub({ ...editedSub, requests_used: e.target.value })}
                    />
                </div>
                <div>
                    <label className="block font-medium">Cycles Remain</label>
                    <input
                        type="number"
                        className="border p-2 w-full"
                        value={editedSub.cycles_remain}
                        onChange={(e) => setEditedSub({ ...editedSub, cycles_remain: e.target.value })}
                    />
                </div>
                <div>
                    <label className="block font-medium">Started At</label>
                    <input
                        type="datetime-local"
                        className="border p-2 w-full"
                        value={editedSub.started_at}
                        onChange={(e) => setEditedSub({ ...editedSub, started_at: e.target.value })}
                    />
                </div>
                <div>
                    <label className="block font-medium">Expired At</label>
                    <input
                        type="datetime-local"
                        className="border p-2 w-full"
                        value={editedSub.expired_at}
                        onChange={(e) => setEditedSub({ ...editedSub, expired_at: e.target.value })}
                    />
                </div>
            </div>
            <div className="mt-4 flex justify-end gap-2">
                <button className="bg-gray-400 text-white p-2 rounded" onClick={() => handleCloseEditSub()}>
                    Cancel
                </button>
                <button
                    className="bg-blue-500 text-white p-2 rounded"
                    onClick={() => {
                        handleUpdateSubscription(originalSub.id, editedSub);
                        handleCloseEditSub();
                    }}
                >
                    Save
                </button>
            </div>
        </div>
    </div>
);
export default EditSubPopup;